<template>
  <!-- 运营标签分类 -->
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getLabelTitleList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="分类名称">
            <el-input v-model="searchForm.labelTitleName" placeholder="请输入分类名称" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getLabelTitleList, true)">查询</el-button>
            <el-button icon="el-icon-refresh"
              @click="$reset(getLabelTitleList, { labelTitleName: null, type: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addLabel">新增分类</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteLabelTitleList">批量删除</el-button>
      </div>
      <div>
        <!-- 标签列表 -->
        <el-table v-loading="loading" :data="labelTitleList" ref="multipleTable" :max-height="tableHeight"
          @selection-change="val => $handleSelectionChange(val, true)" border>
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column type="index" label="序号" width="50" />
          <el-table-column prop="labelTitleName" label="分类名称" />
          <el-table-column prop="createTime" label="创建时间" min-width="150" />
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="primary" @click="editLabel(scope.row)">编辑</el-button>
              <el-button icon="el-icon-delete" type="danger" @click="deleteLabel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination class="mt20" @current-change="page => $handleCurrentChange(page, getLabelTitleList)" :total="total"
          :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" />
      </div>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="350px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="分类名称" prop="labelTitleName">
            <el-input v-model="editForm.labelTitleName" placeholder="请输入分类名称" />
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增分类'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑分类'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script lang="js">
import { labelTitleList, labelTitleEdit, labelTitleDelete, labelTitleAdd } from "@/api/operatelabel"; // 标签请求
export default {
  name: "OperateLabelTitle",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { labelTitleName: null }, // 查询表单
      labelTitleList: [], // 标签列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      multipleSelection: [], // 被选中行
      editFormRules: { labelTitleName: [{ required: true, message: "标签分类不能为空", trigger: "blur" }] }, // 验证规则
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    this.getLabelTitleList(); // 获取标签分类列表
  },
  methods: {
    // 请求所有标签列表
    async getLabelTitleList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await labelTitleList(params);
      if (code == 200) {
        this.total = total;
        this.labelTitleList = rows;
      }
      this.loading = false;
    },
    // 新增标签
    addLabel() {
      this.dialogVisible = true;
      this.dialogTitle = "新增分类";
      this.editForm = { labelTitleName: null, type: "0" };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          labelTitleAdd(this.editForm).then(res => {
            if (res.code == 200) this.$message.success("新增分类成功！");
            this.dialogVisible = false;
            this.$refresh(this.getLabelTitleList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除分类
    deleteLabel(row) {
      this.$confirm('确认删除该分类？').then(_ => { this.del(row.labelTitleId) }).catch(_ => { });
    },
    async del(id) {
      let { code } = await labelTitleDelete(id);
      if (code == 200) this.$message.success("删除分类成功！");
      this.$refresh(this.getLabelTitleList);
    },
    // 批量删除分类
    deleteLabelTitleList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何分类");
      else {
        selected.forEach(item => { selectedId.push(item.labelTitleId) });
        this.$confirm('确认删除该分类？').then(_ => { this.del(selectedId) }).catch(_ => { });
      }
    },
    // 编辑分类
    editLabel(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑分类";
      this.dialogVisible = true;
    },
    // 保存分类修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          labelTitleEdit(this.editForm).then(res => {
            if (res.code == 200) this.$message.success("修改分类成功！");
            this.dialogVisible = false;
            this.$refresh(this.getLabelTitleList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    }
  },
};
</script>